export var VodAnnotationsEvents;!function(n){n.LOADED="loaded"}(VodAnnotationsEvents||(VodAnnotationsEvents={}));